import axios from "axios";
import { handleUnauthorized } from "../utils/sessionManager";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 responses
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const currentPath = window.location.pathname;

    if (status === 401 && currentPath !== "/login" && currentPath !== "/sign-up") {
      await handleUnauthorized(); // ✅ use the helper
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;



// import axios from "axios";

// const axiosInstance = axios.create({
//   // timeout: 5000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });


// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // if (error.response && error.response.status === 401) {
//     //   localStorage.removeItem("token");
//     //   window.location.href = "/login";
//     // }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
